import React from 'react';

// helpers
import useQueryParam from 'hooks/useQueryParam';
import { RoutePaths } from 'routes/routes';

// components
import ApplicationDetails from 'modules/Connections/ApplicationDetails';
import { CardWrapper } from 'components/Additional/CardWrapper';
import { EntityIntakeFormContextProvider } from 'modules/IntakeForm/EntityIntakeForm/EntityIntakeFormContext';

const ApplicationDetailsPage = () => {
  const applicationId = useQueryParam({
    param: 'id',
    noParamRedirect: RoutePaths.Connections_Applications,
  });

  if (!applicationId) {
    return null;
  }

  return (
    <EntityIntakeFormContextProvider>
      <CardWrapper>
        <ApplicationDetails />
      </CardWrapper>
    </EntityIntakeFormContextProvider>
  );
};

export default ApplicationDetailsPage;
